import FieldConfig from "../../../proto/field-config";
import FieldColor from "../../../generic/color/color";
import FieldProjectColor_Editable from "./render/editable";
import FieldProto_TableCell from "../../../proto/render/table/table-cell";
import ItemModel from "../../../../model2/item/item-model";
import TableManager from "../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../gd-modules/task-list/manager/manager";
import {LifecycleAction} from "../../../../gd/const/lifecycle";


export default class FieldProjectColor extends FieldColor {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel  = "Project Color";
        this.label      = "Project Color"

        this.clearButton                    = false

        // this.renderComponents.tableCell = FieldProjectTotalOpenAll_TableCell

        this.renderComponents.editable      = FieldProjectColor_Editable // tut ochen' drugoi render eslio chto...
        this.renderComponents.tableCell      = FieldProto_TableCell // tut ochen' drugoi render eslio chto...


        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    tableCellOnValueChange = (item:ItemModel, value:any, manager:TableManager|TaskListManager) => {


        item.project.color = value
        item.project.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        // need it becuase of workday duration depends on Assignee
        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])

    }

}